import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import { logo } from '../assets';

const Login = () => {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login successful!");
      navigate("/");
    } catch (error) {
      toast.error("Login failed. Please check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex max-md:flex-col w-screen h-screen">
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[35%] bg-gray-100 justify-center items-center border-r">
        <img src={logo} alt="Thirtify Logo" className="w-24 h-fit rounded-lg object-contain" />
      </div>
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[65%] overflow-y-auto scrollbar-hide justify-center items-center">
        <div className="w-full max-w-sm p-6">
          <h2 className="text-2xl font-bold text-center mb-6">Login</h2>
          <form className="flex flex-col gap-4" onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-rose-500"
              disabled={loading}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-rose-500"
              disabled={loading}
              required
            />
            <div className="text-sm text-center">
              Don't have an account?
              <Link to="/register" className="text-rose-500 font-bold ml-1">Register</Link>
            </div>
            <Link to="/forgot-password" className="text-center text-cyan-500 hover:text-rose-500 font-bold ml-1">Forgot Password</Link>
            <button type="submit" className="w-full py-3 bg-rose-600 text-white font-bold rounded-lg hover:bg-rose-700 transition" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;